/* hl-cart-tiers — the volume-discount progress bar at the top of the cart drawer.

   Shape of the problem, and why it is not just "read the cart and draw a bar":

   1. NOTHING HERE FETCHES /cart.js. The drawer re-renders through Shopify's
      Section Rendering API on every change, so the quantities are already in the
      DOM by the time anything could be asked for them. assets/hl-cart-related.js
      established this on the same surface and it is what keeps the cart's idle
      request count at zero.

   2. THE DRAWER IS REPLACED, NOT MUTATED. That re-render swaps the subtree, so a
      node inserted once is gone the next time something is added, and an
      observer bound to a node inside it stops firing. The bar is therefore
      re-seated on every pass, and the observer watches a container that survives.

   3. AN OBSERVER THAT WRITES INTO WHAT IT WATCHES FEEDS ITSELF. Every write below
      is guarded by a comparison against what is already there, so a pass that
      changes nothing performs no DOM write and wakes nothing up. */
(function () {
  var data;
  try { data = JSON.parse(document.getElementById('hl-cart-tiers-data').textContent); }
  catch (e) { return; }
  var TIERS = (data && data.tiers) || [];
  if (!TIERS.length) return;
  var TOP = TIERS[TIERS.length - 1];

  /* Total UNITS, not lines. The automatic discounts are quantity-based — two of
     the same board is a Buy 2 — so a line count would tell the shopper they had
     not reached a tier they were already getting.

     Read from the quantity inputs, which is the only number in the drawer that
     is per-line and authoritative. The header badge is a fallback: it is the
     same figure server-rendered, but it is one element and easy to lose to a
     markup change, whereas the inputs are what the shopper is actually editing. */
  function units(drawer) {
    var q = drawer.querySelectorAll(
      '.cart-items__table-row input[name="updates[]"], .cart-items__table-row input.quantity__input');
    if (q.length) {
      var n = 0;
      for (var i = 0; i < q.length; i++) n += parseInt(q[i].value, 10) || 0;
      if (n) return n;
    }
    var badge = drawer.querySelector('.theme-drawer__badge');
    var b = badge ? parseInt((badge.textContent || '').replace(/\D+/g, ''), 10) : 0;
    return b || 0;
  }

  function reached(n) {
    var r = null;
    for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i].qty) r = TIERS[i];
    return r;
  }
  function next(n) {
    for (var i = 0; i < TIERS.length; i++) if (n < TIERS[i].qty) return TIERS[i];
    return null;
  }

  /* Position along the rail. The milestones are spaced by their ORDER, not by
     their quantity: 2, 3 and 4 are evenly spaced marks on the track, so the
     distance the shopper has to travel between tiers looks the same as the one
     unit it actually is. Spacing them by quantity would put the first mark half
     way along and make the last two tiers look nearly free.

     Position 0 is an empty cart and the first mark is one step in, so the rail
     has somewhere to start from. */
  function pct(n) {
    var steps = TIERS.length;
    if (n <= 0) return 0;
    var i = 0;
    while (i < steps && n >= TIERS[i].qty) i++;
    if (i >= steps) return 100;
    // between mark i-1 (or the start) and mark i
    var lowQty = i === 0 ? 0 : TIERS[i - 1].qty;
    var lowPos = i === 0 ? 0 : (i / steps) * 100;
    var hiPos = ((i + 1) / steps) * 100;
    var span = TIERS[i].qty - lowQty;
    var into = span > 0 ? (n - lowQty) / span : 1;
    return Math.max(0, Math.min(100, lowPos + into * (hiPos - lowPos)));
  }

  function markPct(i) { return ((i + 1) / TIERS.length) * 100; }

  function build() {
    var box = document.createElement('div');
    box.className = 'hl-ct';
    var marks = '';
    for (var i = 0; i < TIERS.length; i++) {
      marks += '<li class="hl-ct__milestone" data-i="' + i + '" style="--mark:' + markPct(i) + '%">' +
        '<span class="hl-ct__dot"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="m3 6 2 2 4-4"/></svg></span>' +
        '<span class="hl-ct__caption"><b>' + TIERS[i].off + '%</b><small>' + TIERS[i].qty + ' items</small></span></li>';
    }
    box.innerHTML =
      '<p class="hl-ct__msg" data-ct-msg role="status" aria-live="polite"></p>' +
      '<div class="hl-ct__progress" role="progressbar" aria-label="Buy more, save more" aria-valuemin="0" aria-valuemax="' + TOP.qty + '">' +
      '<span class="hl-ct__track"><span class="hl-ct__fill"></span></span></div>' +
      '<ol class="hl-ct__milestones" aria-hidden="true">' + marks + '</ol>';
    return box;
  }

  function message(n) {
    var hit = reached(n), up = next(n);
    if (!n) return 'Add ' + TIERS[0].qty + ' items to save <b>' + TIERS[0].off + '%</b>';
    if (!up) return "You're saving <b>" + TOP.off + '%</b> — our best price';
    var need = up.qty - n;
    var more = need === 1 ? '1 more item' : need + ' more items';
    if (!hit) return 'Add <b>' + more + '</b> to save <b>' + up.off + '%</b>';
    return "Saving <b>" + hit.off + '%</b> — add <b>' + more + '</b> for <b>' + up.off + '%</b>';
  }

  /* A CODE IN THE CART TURNS THE LADDER OFF, and the bar has to say so,
     2026-09-23 — owner: "buy 2 nhưng k hiện discount trong drop down … tức là
     sao?". The screenshot had a 13% code applied (one item, $29.99 -> $26.10).
     On this store a discount code and the automatic Buy 2/3/4 do not combine,
     so Shopify kept the code and the Buy 2 never applied — while this bar,
     which counts units rather than reading discounts, said "Saving 10%". The
     dropdown was right; the bar was not.

     The discounts actually applied are in the drawer's DOM (line allocations,
     or the summary's rows at 3+). Any whose name is not a "Buy N" tier is a
     code; when one is present the bar names it and says the tiers do not
     stack, and the ladder dims. The names are text from the theme's own
     markup and are inserted as text. */
  function appliedCode(drawer) {
    var els = drawer.querySelectorAll('.cart-items__discounts li, .cart-drawer__summary .cart-discounts__label');
    for (var i = 0; i < els.length; i++) {
      var name = (els[i].textContent || '').replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
      if (name && !/^buy\s*\d/i.test(name)) return name;
    }
    return '';
  }
  function esc(t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; }
  function paint(box, n, code) {
    box.classList.toggle('hl-ct--code', !!code);
    var msg = box.querySelector('[data-ct-msg]');
    var html = code
      ? 'Code <b>' + esc(code) + '</b> applied — it doesn\u2019t combine with Buy 2/3/4 savings'
      : message(n);
    if (msg.innerHTML !== html) msg.innerHTML = html;


    var up = next(n);
    var progress = box.querySelector('.hl-ct__progress');
    var value = String(code ? 0 : Math.min(n, TOP.qty));
    if (progress.getAttribute('aria-valuenow') !== value) progress.setAttribute('aria-valuenow', value);
    var valueText = msg.textContent;
    if (progress.getAttribute('aria-valuetext') !== valueText) progress.setAttribute('aria-valuetext', valueText);
    var fill = box.querySelector('.hl-ct__fill');
    var scale = String(code ? 0 : pct(n) / 100);
    if (fill.style.getPropertyValue('--progress') !== scale) fill.style.setProperty('--progress', scale);
    for (var i = 0; i < TIERS.length; i++) {
      var el = box.querySelector('.hl-ct__milestone[data-i="' + i + '"]');
      if (!el) continue;
      el.classList.toggle('is-got', !code && n >= TIERS[i].qty);
      el.classList.toggle('is-next', !!(!code && up && TIERS[i].qty === up.qty));
    }
  }

  function render() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    /* The seat: straight after the drawer header, inside the inner wrapper that
       also holds the items. That puts the bar above the scroll container rather
       than in it, so it stays put while the products move. */
    var inner = drawer.querySelector('.cart-drawer__inner');
    /* RELATIVE, NOT PINNED, 2026-09-22. It was seated between the drawer header
       and the scroll container, so it stayed on screen while the products moved
       under it — owner: "phần progress bar save 1 2... là dạng relative (chứ k
       fixed nhé)". It now sits at the top of the scrolling list, so it is the
       first thing in the cart and scrolls away with it. */
    var list = inner && inner.querySelector('.cart-drawer__items');
    if (!inner || !list) return;

    var n = units(drawer);
    var box = drawer.querySelector('.hl-ct');

    /* An empty cart has no ladder to climb and the drawer shows its own empty
       state; a bar there is furniture. */
    if (!n) {
      if (box) box.remove();
      inner.classList.remove('hl-ct-on');
      return;
    }

    if (!box) box = build();
    if (box.parentNode !== list || box !== list.firstElementChild) {
      list.insertBefore(box, list.firstChild);
    }
    /* Marks the drawer as having a bar so the snippet can trim the header's and
       the item list's padding — see the comment on .hl-ct-on. Written only when
       it is not already there: this observer watches its own container. */
    if (!inner.classList.contains('hl-ct-on')) inner.classList.add('hl-ct-on');
    paint(box, n, appliedCode(drawer));
  }

  /* ---- how much room the summary needs ----------------------------------
     The summary is position:fixed over the bottom of the drawer, so the
     scroller has to reserve its height or the last line item can never be
     scrolled clear of it. A literal cannot do that job: the summary's height
     changes with the cart — a Subtotal row appears, a discount row appears, the
     related rail lands in it at one line item. Measured after standing the
     checkout treatment down, a hard-coded 347px left the last item 82px BEHIND
     the summary, with the scroller reporting no overflow at all.

     This lived in assets/hl-cart-totals.js, which is stood down. It is six
     lines and it is a defect fix, so it moves here rather than dying with the
     treatment — this file already runs on every cart change. */
  function publishSummaryHeight() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var sum = drawer.querySelector('.cart-drawer__summary');
    if (!sum) return;
    /* Only a PINNED summary needs room reserved under the list. On desktop the
       theme lays the summary out in flow, and reserving its height there cut
       the list short by exactly that much and left the same amount of blank
       below the payment badges — "trên desktop phần payment k ở dưới cùng". */
    var pinned = getComputedStyle(sum).position === 'fixed';
    var h = pinned ? Math.round(sum.getBoundingClientRect().height) : 0;
    if (pinned && !h) return;
    if (drawer.style.getPropertyValue('--hl-cart-summary-h') === h + 'px') return;
    drawer.style.setProperty('--hl-cart-summary-h', h + 'px');
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; render(); publishSummaryHeight(); });
  }

  /* Observed on <body> rather than on the drawer: the drawer subtree is what
     gets replaced, so an observer rooted inside it would be watching a detached
     node after the first add. childList only — attributes would wake this on
     every class flip in the drawer, and nothing here depends on one. */
  if (typeof MutationObserver === 'function') {
    // Drawer mutations are handled before paint, like the discount row and the
    // badges: the morph can take the bar out, and a rAF left a frame without it.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#cart-drawer')) {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          render();
          publishSummaryHeight();
          return;
        }
      }
      schedule();
    }).observe(document.body, { subtree: true, childList: true });
  }
  document.addEventListener('cart:update', schedule);
  /* Opening Estimated total grows the summary without touching childList, and
     the list then sat 32px behind it. toggle does not bubble; capture it. */
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.closest && e.target.closest('#cart-drawer')) schedule();
  }, true);
  /* A quantity typed rather than stepped does not replace the subtree. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#cart-drawer')) schedule();
  }, true);
  schedule();
})();
